<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.country.editPrice.title' | translate: { bundle: row()?.name } }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-md-6 mb-2">
        <label class="label" for="editCountryWsp">
          {{ 'pricing.country.editPrice.wsp' | translate }}
          @if (priceOf(CountryPriceType.WSP)?.pivot?.validFrom) {
            <span class="text-muted">
              ({{ priceOf(CountryPriceType.WSP).pivot.validFrom | date: 'dd.MM.yyyy' }})
            </span>
          }
        </label>
        <input
          id="editCountryWsp"
          type="number"
          step="any"
          class="form-control"
          data-cy="edit-country-wsp-input"
          [formField]="pricesForm.wsp"
          [placeholder]="'pricing.country.editPrice.wspPlaceholder' | translate"
        />
        @if (!isEditable(CountryPriceType.WSP)) {
          <small class="text-muted">
            {{ 'pricing.country.editPrice.locked' | translate }}
          </small>
        }
        @if (pricesForm.wsp().touched() && pricesForm.wsp().invalid()) {
          @for (error of pricesForm.wsp().errors(); track error.kind) {
            <small class="text-danger d-block">
              {{ 'validation.generic.' + error.kind | translate }}
            </small>
          }
        }
      </div>
      <div class="col-12 col-md-6 mb-2">
        <label class="label" for="editCountryEup">
          {{ 'pricing.country.editPrice.eup' | translate }}
          @if (priceOf(CountryPriceType.EUP)?.pivot?.validFrom) {
            <span class="text-muted">
              ({{ priceOf(CountryPriceType.EUP).pivot.validFrom | date: 'dd.MM.yyyy' }})
            </span>
          }
        </label>
        <input
          id="editCountryEup"
          type="number"
          step="any"
          class="form-control"
          data-cy="edit-country-eup-input"
          [formField]="pricesForm.eup"
          [placeholder]="'pricing.country.editPrice.eupPlaceholder' | translate"
        />
        @if (!isEditable(CountryPriceType.EUP)) {
          <small class="text-muted">
            {{ 'pricing.country.editPrice.locked' | translate }}
          </small>
        }
        @if (pricesForm.eup().touched() && pricesForm.eup().invalid()) {
          @for (error of pricesForm.eup().errors(); track error.kind) {
            <small class="text-danger d-block">
              {{ 'validation.generic.' + error.kind | translate }}
            </small>
          }
        }
      </div>
    </div>
    <div class="notes mt-2">
      {{ 'pricing.country.editPrice.hint' | translate }}
    </div>
  </div>
  <div class="modal-footer">
    <button
      ngbAutofocus
      type="button"
      class="btn btn-clear"
      data-cy="close-btn"
      (click)="modalRef.close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary"
      data-cy="update-country-price-btn"
      [disabled]="submitDisabled()"
      (click)="save()"
    >
      {{ 'common.buttons.btnUpdate' | translate }}
    </button>
  </div>
</div>
